export default __webpack_public_path__ + "static/media/6H.55d939fc.webp";